import React from 'react';
import {FormattedMessage} from 'react-intl';

// TODO: Look into why explicit asterisk is required for this form and forms like it
export default {
    key: 'manualEntryForm',
    fields: [
        {
            name: 'breakId',
            type: 'breakSearch',
            showField: (proxy) => proxy.currentResource.type === 'CHALLENGE',
            required: (proxy) => proxy.currentResource.type === 'CHALLENGE',
            props: {
                validationRules: [
                ]
            }
        },
        {
            name: 'firstName',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.firstName' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'lastName',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.lastName' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'email',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.email' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'address',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.address' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'address2',
            type: 'text',
            props: {
                label: (
                    <div>
                        <FormattedMessage id='prizes.manual.entry.address2' />
                    </div>
                )
            }
        },
        {
            name: 'city',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.city' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'state',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.state' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'zip',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.zip' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'dateOfBirth',
            type: 'date',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.dateOfBirth' />
                    </div>
                ),
                time: false,
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        },
        {
            name: 'phone',
            type: 'text',
            props: {
                label: (
                    <div>
                        <i className='asterisk icon inline'></i>
                        <FormattedMessage id='prizes.manual.entry.phone' />
                    </div>
                ),
                required: true,
                validationRules: [
                    {type: 'NotNullOrBlank'}
                ]
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/pages/ListEntries/manual-entry-config.js